export const shoppingCartActionTypes = {
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    UPDATE_CART_ITEM: "UPDATE_CART_ITEM",
    CLEAR_CART: "CLEAR_CART",
};
